import { render, staticRenderFns } from "./required_fields.vue?vue&type=template&id=2f5e7b22&scoped=true"
import script from "./required_fields.vue?vue&type=script&lang=js"
export * from "./required_fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5e7b22",
  null
  
)

export default component.exports